import { PERSONDATAPOLITIK_URL } from "@cle/constants/links";

type AiScreeningNoticeProps = {
  /** Bestemt form, flertal: "Kursusbeviserne", "Forsikringspolicerne". */
  subject: string;
  /** `full` i upload-dialogen, `short` på kortet, hvor pladsen er én linje. */
  variant?: "full" | "short";
};

/**
 * Oplyser medlemmet om AI-screeningen, *inden* dokumentet uploades. Teksten står
 * kun her, fordi den skal være ens på begge upload-veje (dialogen og
 * drag-and-drop på kortet) og på begge dokumenttyper, der screenes af AI —
 * kursusbeviser og forsikringspolicer. De øvrige dokumenttyper gennemgås af
 * sekretariatet og skal ikke have denne tekst, jf. `ManualReviewInfoModal`.
 *
 * Renderer bevidst ingen egen `<p>`: kaldstederne lægger den ind i deres egen
 * tekstblok (dialogen) eller i `RoundedCard`s `description`.
 */
const AiScreeningNotice = ({
  subject,
  variant = "full",
}: AiScreeningNoticeProps) => {
  const link = (
    <a href={PERSONDATAPOLITIK_URL} target="_blank" rel="noreferrer">
      Advokatsamfundets persondatapolitik
    </a>
  );

  if (variant === "short") {
    return (
      <>
        {subject} screenes med brug af AI — læs mere i {link}.
      </>
    );
  }

  return (
    <>
      {subject} bliver screenet med brug af AI og bliver enten godkendt eller
      afvist efter analysen. Hold derfor øje med status i oversigten, når
      uploaden er modtaget. Læs mere om behandlingen af dine oplysninger i{" "}
      {link}.
    </>
  );
};

export default AiScreeningNotice;
